import { persistentReducedStream, reducer } from '@ardoq/rxbeach';
import { setLucidSlideState } from 'integrations/lucidchart/actions';
import { LucidSlideState } from './lucidSlideTypes';

const defaultState: LucidSlideState = {
  clientId: null,
};

const setLucidSlideData = (
  _: LucidSlideState,
  newState: LucidSlideState
): LucidSlideState => newState;

const lucidSlide$ = persistentReducedStream<LucidSlideState>(
  'lucidSlide$',
  defaultState,
  [reducer(setLucidSlideState, setLucidSlideData)]
);

export { lucidSlide$ };
